/**
 * useSyncOnReconnect — хук автоматичної синхронізації при відновленні з'єднання
 *
 * Слухає зміни pwaManager.isOffline через MobX reaction.
 * Коли стан переходить true → false (з'явився інтернет),
 * автоматично запускає offlineSyncManager.sync().
 *
 * Підключати один раз у DriverLayoutTemplate.
 */

import { useEffect, useRef } from 'react'
import { reaction } from 'mobx'
import { pwaManager } from '../PwaManager'
import { offlineSyncManager } from './OfflineSyncManager'

export function useSyncOnReconnect(): void {
    const prevOfflineRef = useRef<boolean>(pwaManager.isOffline)

    useEffect(() => {
        const dispose = reaction(
            () => pwaManager.isOffline,
            (isOffline) => {
                if (!isOffline && prevOfflineRef.current) {
                    // Відновлення з'єднання — запускаємо синхронізацію
                    offlineSyncManager.sync()
                }
                prevOfflineRef.current = isOffline
            },
        )

        return dispose
    }, [])
}
